module.exports = __webpack_public_path__ + "img/baner-9.webp";